import { AlertCircle } from 'lucide-react';
import Model from '../models/Model';
import { ModalProps } from '@/interfaces/common.interface';
import BtnLoader from '@/components/UI/loaders/BtnLoader';

const SyncProductModel: React.FC<ModalProps> = ({
  onClose,
  show,
  onSubmit,
  isLoading,
}) => {
  return (
    <Model
      show={show}
      onClose={() => {
        if (!isLoading) {
          onClose();
        }
      }}
      size="w-[500px]"
    >
      <div className=" p-6 text-center">
        <div className="flex justify-center mb-4">
          <div className="bg-yellow-100 p-4 rounded-full">
            {<AlertCircle className="text-yellow-600 w-10 h-10" />}
          </div>
        </div>

        <h2 className="text-lg font-semibold text-gray-900">Are you sure?</h2>
        <p className="text-gray-500 mt-1">You want to sync your products?</p>

        <div className="flex justify-between mt-6">
          <button
            onClick={onClose}
            className="w-[48%] bg-gray-200 text-gray-700 font-medium py-2 rounded-lg hover:bg-gray-300 transition"
            disabled={isLoading}
          >
            Cancel
          </button>
          <button
            onClick={onSubmit}
            className="w-[48%] btn-primary flex items-center gap-2"
          >
            {isLoading ? <BtnLoader /> : 'Sync Products'}
          </button>
        </div>
      </div>
    </Model>
  );
};

export default SyncProductModel;
